import React from 'react';
import * as styles from './allhomes-listing-badges.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ListingBadge = _ref => {
  var badge = _ref.badge,
    label = _ref.label,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    bgColour = _ref.bgColour,
    color = _ref.color;
  return ___EmotionJSX("div", {
    css: styles.badge(badge, size, bgColour, color)
  }, label !== null && label !== void 0 ? label : badge.label);
};